// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"12d3df66abda7c7c","777":"0f2e3acceb9b1cb7"}[chunkId] + ".js";
};